import React from 'react';
import SimpleLayout from './layouts/SimpleLayout';
import MainLayout from './layouts/MainLayout';
import Login from './views/Login';
import MultiVehicle from './views/MultiVehicle';
import SingleView from './views/SingleView';
import { Navigate, useSearchParams } from 'react-router-dom';
import CockpitManage from './views/CockpitManage';
import Home from './views/Home';

const SingleViewWrapper = () => {
  const [searchParams] = useSearchParams();
  const vehicleName = searchParams.get('vehicleName');
  return <SingleView key={vehicleName} />;
};

const MultiVehicleWrapper = () => {
  const key = React.useMemo(() => Date.now(), []);
  return <MultiVehicle key={key} />;
};

const routes: any[] = [
  {
    path: '/',
    element: <SimpleLayout />,
    children: [
      { index: true, element: <Navigate to="login" /> },
      { path: 'login', element: <Login /> },
    ],
  },
  {
    path: '/app',
    element: <MainLayout />,
    children: [
      { index: true, element: <Navigate to="home" /> },
      { path: 'home', element: <Home /> },
      { path: 'multivehicle', element: <MultiVehicleWrapper /> },
      { path: 'singleview', element: <SingleViewWrapper /> },
      { path: 'cockpitmanage', element: <CockpitManage /> },
    ],
  },
];

export default routes;
